<dx-drop-down-box
    #selectorDropdownBox
    contentTemplate="contentTemplate"
    fieldTemplate="textfieldTemplate"
    [valueExpr]="selectedAccountValueExpr"
    [displayExpr]="selectedAccountDisplayExpr"
    [dataSource]="accountSource"
    [dropDownOptions]="{ width: 320, height: 180 }"
    [showClearButton]="true"
    [openOnFieldClick]="true"
    [(value)]="selectedAccountCode"
    (onKeyDown)="onDropdownBoxKeyDown($event)"
    (onKeyUp)="onDropdownBoxKeyUp($event)"
    (onValueChanged)="onDropdownValueChanged($event)"
    (onOpened)="onDropDownOpened($event)"
>
    <div *dxTemplate="let data of 'textfieldTemplate'" class="dropdown-textfield">
        <dx-text-box
            #dropDownBoxTextBox
            width="100%"
            [showClearButton]="true"
            [readOnly]="true"
            [value]="selectedAccountName"
        ></dx-text-box>
    </div>

    <div *dxTemplate="let e of 'contentTemplate'" class="tab-content">
        <dx-box width="100%" height="100%" direction="col" class="tab-box-container">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-tabs
                        [width]="280"
                        keyExpr="name"
                        class="cc-tabs"
                        itemTemplate="tabTemplate"
                        [dataSource]="accountTypeSource"
                        [(selectedItem)]="selectedTabItem"
                        (onItemClick)="onTabSelection()"
                    >
                        <div *dxTemplate="let d of 'tabTemplate'" class="tab-items">
                            {{ d.text }}
                        </div>
                    </dx-tabs>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1" [visible]="selectedAccountType === 'account_label'">
                <div *dxTemplate class="add-top-padding">
                    <ng-container *ngIf="glAccountLabelSource?.length === 0">No Account Labels present</ng-container>
                    <ng-container *ngIf="glAccountLabelSource?.length > 0">
                        <app-grid-cell-multi-column-selector
                            #accountLabelSelector
                            [name]="'Account Label'"
                            [cellInfo]="cellInfo"
                            [gridSource]="glAccountLabelSource"
                            [boxValue]="accountLabelBoxValue"
                            [dropDownButtonTemplate]="'dropDownButton'"
                            [dropDownOptions]="{ width: 700 }"
                            [valueExpr]="'code'"
                            [displayExpr]="'title'"
                            [columnDef]="accountLabelColumns"
                            [showClearButton]="true"
                            [placeholder]="'Search Account Label...'"
                            (gridSelectionEvent)="onAccountLabelSelection($event)"
                            (keyPressedEvent)="onAccountLabelKeyPressed($event)"
                        ></app-grid-cell-multi-column-selector>
                    </ng-container>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1" [visible]="selectedAccountType === 'account_number'">
                <div *dxTemplate class="add-top-padding">
                    <div class="column-container">
                        <div class="column-content">
                            <div class="full-width">GLAccount</div>
                            <div class="full-width">
                                <app-grid-cell-multi-column-selector
                                    #glAccountSelector
                                    [name]="'GL Account'"
                                    [gridSource]="glAccounts"
                                    [cellInfo]="cellInfo"
                                    [boxValue]="glAccountBoxValue"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 700 }"
                                    [valueExpr]="'glAccountNumber'"
                                    [displayExpr]="'displayText'"
                                    [columnDef]="glAccountColumns"
                                    [showClearButton]="true"
                                    [placeholder]="'Search GL Account...'"
                                    (gridSelectionEvent)="onGLAccountSelection($event)"
                                    (keyPressedEvent)="onGLAccountKeyPressed($event)"
                                ></app-grid-cell-multi-column-selector>
                            </div>
                        </div>
                        <div class="column-content">
                            <div class="full-width">Offset GLAccount</div>
                            <div class="full-width">
                                <app-grid-cell-multi-column-selector
                                    #offsetGLAccountSelector
                                    [name]="'Offset GL Account'"
                                    [gridSource]="glAccounts"
                                    [cellInfo]="cellInfo"
                                    [boxValue]="offsetGlAccountBoxValue"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 700 }"
                                    [valueExpr]="'glAccountNumber'"
                                    [displayExpr]="'displayText'"
                                    [columnDef]="glAccountColumns"
                                    [showClearButton]="true"
                                    [placeholder]="'Search Offset Account...'"
                                    [disabled]="disableOffsetGLAccount"
                                    (gridSelectionEvent)="onOffsetGLAccountSelection($event)"
                                    (keyPressedEvent)="onOffsetGLAccountKeyPressed($event)"
                                ></app-grid-cell-multi-column-selector>
                            </div>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-drop-down-box>
